import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const Close = createSvgIcon(
  <path d="m12 10.409-7.69-7.69L2.72 4.31 10.408 12l-7.69 7.69 1.591 1.59L12 13.592l7.69 7.69 1.59-1.591L13.59 12l7.69-7.69-1.59-1.59L12 10.408Z" />,
  'Close'
);

export { Close };
